import React from "react";

function Home() {
  return (
    <>
      <h1>Home Page</h1>
      <p>this is Home</p>
    </>
  );
}

export default Home;
